import { RegistriesConfig } from "@codman/patients-like-me/util-services";
import { dcraConfig } from "./dcra";

export const registryConfigs: RegistriesConfig = {
    dcra: dcraConfig,
};

export const defaultRegistry = "dcra";
